import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import { Chip, Typography } from "@mui/material";
import { useCheckUserPermission } from "../../../../../api/hooks/useCheckUserPermission";
import useColors from "../../../../../api/hooks/useColors";
import CustomToolTip from "../../../../../components/CustomTooltip";
import LoadingIcon from "../../../../../components/LoadingIcon";
import { descriptionToSVGbyCategory } from "../../../../../icons/IconMappingSVG";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import {
  AssetClass,
  PLATFORM_USER_ACTIONS,
} from "../../../../../utils/constants";
import { ReactComponent as CriticalAssetIcon } from "../../icons/criticalAsset.svg";

const AssetChip = ({
  asset,
  handleClick = null,
  isPending = false,
  handleDelete = null,
  sx = {},
  tooltipTitle = null,
  tooltipPosition = "bottom",
}) => {
  const colors = useColors();

  const { permitted: hasPermission } = useCheckUserPermission(
    PLATFORM_USER_ACTIONS.MODIFY_ASSET
  );

  const AssetTypeIcon =
    asset.type === "Other" ? (
      <SvgToIcon
        IconLogo={CriticalAssetIcon}
        width="16px"
        height="16px"
        style={{ color: colors.chip_inventory_icon_color }}
      />
    ) : (
      <SvgToIcon
        IconLogo={descriptionToSVGbyCategory["asset"][asset.type]}
        width="18px"
        height="18px"
        style={{ color: colors.chip_inventory_icon_color }}
      />
    );

  return (
    <CustomToolTip
      title={
        <Typography variant="caption">
          {tooltipTitle
            ? tooltipTitle
            : `${asset.name} is a Smart Critical Asset and is managed automatically by
          Breeze. You can turn it on or off on the Critical Assets page`}
        </Typography>
      }
      disableHoverListener={
        (asset?.cls === AssetClass.REGULAR && !tooltipTitle) ||
        tooltipTitle === ""
      }
      placement={tooltipPosition}
    >
      <Chip
        key={asset.name}
        sx={{
          background: colors.chip_inventory_enabled_bg,
          fontSize: "12px",
          fontFamily: "Poppins",
          fontWeight: 400,
          lineHeight: "16px",
          color: colors.text_primary,
          padding: "0 6px",
          boxShadow: colors.chip_inventory_enabled_shadow,
          height: "24px",
          borderRadius: "8px",
          gap: "4px",
          "& .MuiChip-icon": {
            margin: 0,
          },
          "& .MuiChip-label": {
            padding: "0 4px",
          },
          "& .MuiChip-deleteIcon": {
            visibility: "hidden",
            margin: 0,
          },
          "&:hover .MuiChip-deleteIcon": {
            visibility: handleDelete ? "visible" : "hidden",
          },
          "&:hover": {
            backgroundColor: colors.chip_inventory_enabled_bg,
            opacity: 1,
          },
          ...sx,
        }}
        label={asset.name}
        icon={AssetTypeIcon}
        onClick={handleClick}
        onDelete={
          handleDelete && asset.cls === AssetClass.REGULAR
            ? () => handleDelete(asset)
            : null
        }
        deleteIcon={
          !handleDelete ? null : isPending ? (
            <LoadingIcon size={16} />
          ) : asset.cls === AssetClass.REGULAR && hasPermission ? (
            <ClearRoundedIcon sx={{ width: "16px" }} />
          ) : null
        }
      />
    </CustomToolTip>
  );
};

export default AssetChip;
